import React, { Component } from "react";
import styles from "./logisticReports.module.scss";
import getDates from "../../../shared/services/date.service";
import LogisticReportsControlPointMap from "./LogisticReportsControlPointMap";
import { controlPointStatus } from "./LogisticReportsControlPointStatus";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import { NavLink } from "react-router-dom";

class LogisticReportsControlPointItem extends Component {
  render() {
    const { controlPoint, onSetViewPanel } = this.props;

    const isViolation =
      (controlPoint.taskTrip !== undefined && controlPoint.taskTrip.isCompleted && controlPoint.status !== 1) || controlPoint.status > 1;

    return (
      <div className={styles.reportItemContainer}>
        <div className={styles.columnItem}>
          <div>
            <b>Контрольная точка: </b> <span> {controlPoint.title}</span>
          </div>

          <div>
            <b>{controlPoint.isChangeAlarm ? "Начало изменено" : "Начало"}: </b>{" "}
            <span> {getDates.getDateFormat8(controlPoint.timeStart)}</span>
          </div>

          <div>
            <b>{controlPoint.isChangeAlarm ? "Окончание изменено" : "Окончание"}: </b>{" "}
            <span> {getDates.getDateFormat8(controlPoint.timeEnd)}</span>
          </div>

          <div>
            <b>Статус: </b> <span style={{ color: isViolation ? "red" : "black" }}> {controlPointStatus[controlPoint.status]}</span>
          </div>

          {controlPoint.status !== 0 ? (
            <div>
              <b>Время события: </b> <span> {getDates.getDateFormat9(controlPoint.timeEvent)}</span>
            </div>
          ) : null}

          <div>
            <b>Адрес: </b> <span> {controlPoint.address}</span>
          </div>

          <div>
            <b>Адрес по локации: </b> <span> {controlPoint.geocoderAddress}</span>
          </div>

          {controlPoint.description !== null && controlPoint.description !== "" ? (
            <div>
              <b>Описание: </b> <span> {controlPoint.description}</span>
            </div>
          ) : null}

          {controlPoint.isVariation ? (
            <div>
              <b>Параметры контрольной точки изменены!</b>
            </div>
          ) : null}

          <div>
            <b>Радиус: </b> <span> {controlPoint.radius} м.</span>
          </div>

          <div>
            <b>Максимальная скорось: </b> <span> {controlPoint.maxSpeed} км./ч.</span>
          </div>
        </div>

        {controlPoint.route !== undefined ? (
          <div className={styles.columnItem}>
            <div>
              <b>Маршрут: </b> <span> {controlPoint.route.title}</span>
            </div>

            <div>
              <b>{controlPoint.route.isChangeAlarm ? "Начало изменено" : "Начало"}: </b>{" "}
              <span> {getDates.getDateFormat8(controlPoint.route.timeStart)}</span>
            </div>

            <div>
              <b>{controlPoint.route.isChangeAlarm ? "Окончание изменено" : "Окончание"}: </b>{" "}
              <span> {getDates.getDateFormat8(controlPoint.route.timeEnd)}</span>
            </div>
          </div>
        ) : null}

        {controlPoint.taskTrip !== undefined ? (
          <div className={styles.columnItem}>
            <div>
              <b>Рейс: </b>
              <TooltipWrapper title={`Просмотреть рейс ${controlPoint.taskTrip.title}`} position="top">
                <NavLink to={`/logistic/reports/${controlPoint.taskTrip.id}`}>
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      onSetViewPanel("taskTripReport");
                    }}
                  >
                    {controlPoint.taskTrip.title}
                  </span>
                </NavLink>
              </TooltipWrapper>
            </div>

            <div>
              <b>Начало: </b> <span> {getDates.getDateFormat8(controlPoint.taskTrip.timeStart)}</span>
            </div>

            <div>
              <b>Окончание: </b> <span> {getDates.getDateFormat8(controlPoint.taskTrip.timeEnd)}</span>
            </div>

            <div>
              <b>Состояние: </b> <span> {controlPoint.taskTrip.isCompleted ? "Завершен" : "В процессе"}</span>
            </div>

            <div>
              <b>Исполнение: </b>{" "}
              <span style={{ color: controlPoint.taskTrip.isViolation ? "red" : "black" }}>
                {controlPoint.taskTrip.isViolation ? "С нарушениями" : "Без нарушений"}
              </span>
            </div>

            <div>
              <b>Транспортное средство: </b> <span> {controlPoint.unit.title}</span>
            </div>

            <div>
              <b>Регистрационный номер: </b> <span> {controlPoint.unit.registerNumber}</span>
            </div>
          </div>
        ) : null}

        <div className={styles.columnItem}>
          <LogisticReportsControlPointMap controlPoint={controlPoint} />
        </div>
      </div>
    );
  }
}

export default React.memo(LogisticReportsControlPointItem);
